//swiper
import Swiper from 'swiper/bundle';
/* import Swiper, { Thumbs } from 'swiper';
Swiper.use([Thumbs]); */
/* import "swiper/css/bundle"; */

export default class Modal {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }


    setSwiper() {
        const thumb = new Swiper('.benefits__thumb__swiper', {
            slidesPerView: 'auto',
            clickable: true,
        });

        const swiper = new Swiper('.benefits__swiper', {
           // Optional parameters

           pagination: {
               el: '.swiper-pagination',
               clickable: true,
           },
           navigation: {
               nextEl: '.swiper-button-next_8',
               prevEl: '.swiper-button-prev_8',
           },
           thumbs: {
                swiper: thumb,
            },
       });

       const thumb3 = new Swiper(".benefits__thumb__swiper__3", {
           slidesPerView: "auto",
           clickable: true,
       });

       const swiper3 = new Swiper(".benefits__swiper__3", {
           // Optional parameters

           pagination: {
               el: ".swiper-pagination",
               clickable: true,
           },
           navigation: {
               nextEl: ".swiper-button-next_3",
               prevEl: ".swiper-button-prev_3",
           },
           thumbs: {
               swiper: thumb3,
           },
       });

       const thumb2 = new Swiper('.benefits__thumb__swiper__2', {
           slidesPerView: 'auto',
           clickable: true,
       });

       const swiper2 = new Swiper('.benefits__swiper__2', {
           // Optional parameters

            pagination: {
               el: '.swiper-pagination',
               clickable: true,
            },
            navigation: {
               nextEl: '.swiper-button-next_2',
               prevEl: '.swiper-button-prev_2',
            },
            thumbs: {
               swiper: thumb2,
            },
       });

       const thumb1 = new Swiper(".benefits__thumb__swiper__1", {
           slidesPerView: "auto",
           clickable: true,
       });

       const swiper1 = new Swiper(".benefits__swiper__1", {
           // Optional parameters

           pagination: {
               el: ".swiper-pagination",
               clickable: true,
           },
           navigation: {
               nextEl: ".swiper-button-next_1",
               prevEl: ".swiper-button-prev_1",
           },
           thumbs: {
               swiper: thumb1,
           },
       });

     
    }
}
